import { Avatar, Button, Card, Group, MantineTheme, Stack, Text, Title } from "@mantine/core";
import { Entity, EntityDefinition, latLng, RecordGroupManager, useEntityUI, ValuesRecord } from "@mcurros2/microm";
import { DisponibleEnRutasViewColumnsOverrides } from "./DisponibleEnRutasViewColumnsOverrides";
import { SolicitudesRuteo } from "./SolicitudesRuteo";

export function DisponibleEnRutasViewInfoWindowRenderer(
    record: ValuesRecord,
    position: latLng,
    groupManager: RecordGroupManager,
    infoWindow: google.maps.InfoWindow,
    UIAPI: ReturnType<typeof useEntityUI>,
    theme: MantineTheme,
    entity: Entity<EntityDefinition>
) {
    const columnsRender = DisponibleEnRutasViewColumnsOverrides(theme);
    const personal_id = record[0] as string;
    const apellido = record[3] as string;
    const nombre = record[4] as string;
    const puesto = record[5] as string;
    const horario = record[6] as string;
    const horas_disponibles = record[7] as number | null;
    const baja = record[10] as string;
    const licencia = record[11] as string;
    const supervisor = record[12] as string;
    const vc_fotoguid = record[25] as string;
    const ruta_id = record[26] as string;

    const SolicitudesRuteo = entity as SolicitudesRuteo;

    const fotoURL = entity.API.client.getDocumentURL(vc_fotoguid);

    const group = groupManager.getGroupByLocation(position);
    if (group) {
        return (
            <Card withBorder>
                <Stack spacing="xs" mb="xs">
                    {group.records.map(
                        ({ recordValue: rec }, index) => <Group key={`grp_${rec[0]}`}>
                            <Title order={5}>{`ID: ${rec[0]} ${rec[3]}, ${4}${rec[5] ? ' - ' : ''}${rec[5]}`}</Title>
                            <Button size="xs" onClick={async () => {
                                await UIAPI.handleExecuteAction(
                                    SolicitudesRuteo.def.clientActions.ACTEditarRuta,
                                    [{ 'c_personal_id': rec[0] }]
                                );
                            }} >Editar</Button>
                            <Button size="xs" onClick={async () => {
                                await UIAPI.handleExecuteAction(
                                    SolicitudesRuteo.def.clientActions.ACTEliminarRuta,
                                    [{ 'c_personal_id': rec[0], 'c_tiposolicitudruta_id': 'ELIMINAR' }]
                                );
                            }} >Eliminar</Button>
                        </Group>
                    )
                    }
                    <Group>
                        <Button size="xs" variant="light" onClick={() => {
                            infoWindow.close();
                        }}>Cerrar</Button>
                    </Group>
                </Stack>
            </Card>
        )
    }
    else {
        const horario_asignado = columnsRender[6]!.render!(horario);
        const horas_semanales_disponibles = columnsRender[7]!.render!(horas_disponibles);
        const estado_baja = columnsRender[10]!.render!(baja);
        const estado_licencia = columnsRender[11]!.render!(licencia);

        const client = entity.API.client;

        return (
            <Card withBorder padding="xs">
                <Stack spacing="0.5rem">
                    <Group spacing="xs">
                        <Avatar size="md" src={fotoURL} radius="sm" />
                        <Title order={4}>{`${apellido}, ${nombre}`}</Title>
                    </Group>
                    <Group spacing="xs">
                        <Text weight={500} size="sm">Puesto: </Text>
                        {puesto}
                    </Group>
                    <Group spacing="xs">
                        <Text weight={500} size="sm">Supervisión: </Text>
                        {supervisor}
                    </Group>
                    <Group spacing="0rem">
                        <Text mr="xs" weight={500} size="sm">Horas pactadas: </Text>
                        {horario_asignado}
                    </Group>
                    {horas_semanales_disponibles &&
                        <Group spacing="0rem">
                            <Text mr="xs" weight={500} size="sm">Horas semanales disponibles: </Text>
                            {horas_semanales_disponibles}
                        </Group>
                    }
                    {estado_licencia &&
                        <Group spacing="0.5rem">
                            {estado_licencia}
                        </Group>
                    }
                    {estado_baja &&
                        <Group spacing="0.5rem">
                            {estado_baja}
                        </Group>
                    }
                    <Group position="right">
                        <Button size="xs" variant="light" onClick={() => {
                            infoWindow.close();
                        }}>Cerrar</Button>
                        <Button size="xs" onClick={async () => {
                            await UIAPI.handleExecuteAction(
                                SolicitudesRuteo.def.clientActions.ACTEditarRuta,
                                [{ 'c_personal_id': personal_id }]
                            )
                        }} >Editar</Button>
                        <Button size="xs" onClick={async () => {
                            await UIAPI.handleExecuteAction(
                                SolicitudesRuteo.def.clientActions.ACTEliminarRuta,
                                [{ 'c_personal_id': personal_id, 'c_tiposolicitudruta_id': 'ELIMINAR' }]
                            )
                        }} >Eliminar</Button>
                    </Group>
                </Stack>
            </Card>
        )
    }
}